var map = {
	"./eye-close.png": "8aZL",
	"./eye-open.png": "pj+X"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rlqM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp ^\.\/eye\-.*\.png$
// module id = rlqM
// module chunks = 0